import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import UserService from '../../Services/http/UserService';
import userRoles from '../../configs/userRolesConfigs';
import AccountService from '../../Services/http/AccountService';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function AwsSuccessDialog() {
    const [open, setOpen] = useState(false);
    const [emailFromRefund, setEmailFromRefund] = useState(null);
    const userRole = useSelector((state: any) => state.general.userRol);
    const [disabledButton, setDisabledButton] = useState(false);
    const defaultAccount = useSelector(
        (state: any) => state.account.default_account
    );

    const handleClose = () => {
        setOpen(false);
    };

    const handleInviteUs = () => {
        setDisabledButton(true);
        AccountService.updateIsSendInvite(defaultAccount.id, true)
        .then(res => {
            if (res && res['message'] === 'success') {
                setOpen(false);
            } else {
                setDisabledButton(false);
            }
        });

    };

    useEffect(() => {
        if (userRole === userRoles.account && defaultAccount && defaultAccount.id) {
            // AccountService.checkIfNeedUserAuthorizationStep(defaultAccount.id)
            //     .then(res => {
            //         if (res && res['response'] && res['email_from_refund']) {
            //             setEmailFromRefund(res['email_from_refund']);
            //             setOpen(true);
            //         }
            //     });
            setOpen(false);
        } else {
            setOpen(false);
        }
    }, [defaultAccount]);

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Hello and welcome to Better Refunds!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* Thank you for initiating the audit process.<br></br>
                        Our API system will soon begin collating various reports from your account over the last 18 months.<br></br>
                        By combing and sifting through the data, we will find what can be immediately reimbursed, the estimated value, and a projected estimate of monthly to yearly savings through our service.<br></br>
                        The whole process will take approximately 24 to 48 hours, as we want to be as thorough and as accurate as possible.<br></br>
                        When the audit process is done, the report will be sent to your E-mail.<br></br>
                        Looking forward to having you with us! */}
                        <span>Please invite us as a user on your Seller Central.</span><br /><br />
                        <span>We will accept it shortly.</span><br /><br />
                        <span>User: <span className='bold'>Refunds</span></span><br></br>
                        <span>Email: <span className='bold'>{emailFromRefund}</span></span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button onClick={handleInviteUs} disabled={disabledButton}>Invite Us</Button>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
}